import angular from 'angular';
import delegatedCardListMobileComponent from './delegatedCardListMobile.component';

let delegatedCardListMobileModule = angular.module('delegatedCardListMobile', [])

  .component('delegatedCardListMobile', delegatedCardListMobileComponent)

  .name;

export default delegatedCardListMobileModule;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/delegatedCardListMobile/delegatedCardListMobile.js